import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ErreurComponent} from './erreur/erreur.component';
import {RouterModule} from '@angular/router';

const routes = [
	{
		path: 'erreur',
		component: ErreurComponent,
	}
]

@NgModule({
	declarations: [ErreurComponent],
	imports: [
		CommonModule,
		RouterModule.forChild(routes)
	]
})
export class PagesModule {
}
